<mat-tab-group  mat-stretch-tabs="false" mat-align-tabs="start">
  <mat-tab label="B&B / HOTEL / MOTEL OWNER">
    <app-enrollment-owner [enrollment]="enrollment"></app-enrollment-owner>
  </mat-tab>
  <mat-tab label="B&B / HOTEL / MOTEL LICENSE">
    <app-mgmt-company-license [enrollment]="enrollment"></app-mgmt-company-license>
  </mat-tab>
  <mat-tab label="RENTAL  PROPERTY">
    <app-individual-bed-rental [enrollment]="enrollment"></app-individual-bed-rental>
  </mat-tab>
  <mat-tab label="RENTAL  PROPERTY REPORTING">
    <app-enrollment-property-reporting  [hide-responsibility]="true" [enrollment]="enrollment"></app-enrollment-property-reporting>
  </mat-tab>
  <mat-tab label="RENTAL PROPERTY LICENSES">
    <app-enrollment-property-licenses [license]="license"></app-enrollment-property-licenses>
  </mat-tab>
</mat-tab-group>
